import { buildHtml, ContentRoute, RouteSlotInput } from '@caritas/ui';

import { isDefined } from '../../utils/is-defined';
import { mapImage } from '../Image.mappers';

export function mapFileList(
  input: BlockFileListFragment,
): RouteSlotInput<typeof ContentRoute, 'body', 'fileLinksblock'> {
  return {
    key: 'fileLinksblock',
    input: () => [
      {
        title: input?.fileListHeading,
        anchor: input?.fileListAnchor,
        content: {
          items: [
            {
              key: 'formattedText',
              input: {
                Content: buildHtml(`<p>${input.fileListContent || ''}</p>`),
              },
            },
          ],
        },
        files:
          input.files?.filter(isDefined).map((file) => {
            return {
              fileUrl: file?.file?.file.url || '',
              title: file?.file?.title || '',
              size: file?.file?.file.size || '',
              type: file?.file?.file.mimeType || '',
              Description: buildHtml(`<p>${file?.file?.caption || ''}</p>`),
              // Only images can have the source field, and typescript reports
              // an error that they are not found on other media types. However,
              // we know that, so we can ignore the warning.
              // @ts-ignore
              Source: file?.file?.source
                // @ts-ignore
                ? buildHtml(`<p>©&nbsp;${file?.file?.source}</p>`)
                : undefined,
              Image: mapImage({
                image: file.file?.image,
                preset: 'file_list',
                caption: file.file?.caption,
              }),
            };
          }) || [],
      },
      200,
    ],
  };
}
